module.exports = __webpack_public_path__ + "img/servizi 2.7666e731.jpeg";